var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{ref:"apptop",staticClass:"app-mian"},[_c('router-view')],1),_c('router-view',{staticClass:"app-footer",attrs:{"name":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }